import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import TeamMember from "./pages/TeamMember";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const RootRedirect = () => {
  const saved = localStorage.getItem("pi_lang");
  const lang = saved === "en" ? "en" : "de";
  return <Navigate to={`/${lang}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/:lang" element={<Home />} />
              <Route path="/:lang/about" element={<About />} />
              <Route path="/:lang/team" element={<Team />} />
              <Route path="/:lang/team/:slug" element={<TeamMember />} />
              <Route path="/:lang/news" element={<News />} />
              <Route path="/:lang/news/:id" element={<NewsDetail />} />
              <Route path="/:lang/contact" element={<Contact />} />
              <Route path="/:lang/impressum" element={<Legal docKey="impressum" />} />
              <Route path="/:lang/datenschutz" element={<Legal docKey="datenschutz" />} />
              <Route path="*" element={<RootRedirect />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
          <Toaster />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
